"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocalStorageState = useLocalStorageState;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable prettier/prettier */
function useLocalStorageState(key, defaultValue) {
  var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _React$useState = React.useState(function () {
    var valueInLocalStorage = enabled ? window.localStorage.getItem(key) : undefined;

    if (valueInLocalStorage) {
      return JSON.parse(valueInLocalStorage);
    }

    return defaultValue;
  }),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var prevKeyRef = React.useRef(key);
  React.useEffect(function () {
    var prevKey = prevKeyRef.current;

    if (prevKey !== key) {
      window.localStorage.removeItem(prevKey);
    }

    prevKeyRef.current = key;

    if (enabled) {
      window.localStorage.setItem(key, JSON.stringify(state));
    }
  }, [key, state, enabled]);
  var setStateNoop = React.useMemo(function () {
    return function (value) {// This is a no-op function for when a hook is disabled, adding this comment to fix eslint
    };
  }, []);
  return [enabled ? state : undefined, enabled ? setState : setStateNoop];
}